import type { SVGProps } from "react";
export interface TelephoneRetroIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TelephoneRetroIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TelephoneRetroIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 18.485a4.88 4.88 0 0 0-1.428-3.447l-2.913-2.914H9.465l-2.912 2.914a4.88 4.88 0 0 0-1.428 3.447V20c0 .483.391.875.875.875h12a.877.877 0 0 0 .875-.875zM21.125 20c0 1.725-1.4 3.125-3.125 3.125H6A3.126 3.126 0 0 1 2.875 20v-1.515c0-1.89.751-3.702 2.087-5.038l3.242-3.243.171-.14c.184-.123.4-.19.625-.19h.375V9a1.125 1.125 0 0 1 2.25 0v.874h.75V9a1.125 1.125 0 0 1 2.25 0v.874h.374l.222.022c.216.044.416.15.574.308l3.243 3.243a7.13 7.13 0 0 1 2.087 5.038z"
      />
      <path
        fill={color}
        d="M12.875 17a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0M8.048 4.922a17.1 17.1 0 0 1 8.458.14l1.29.352c.57.156.922.727.806 1.307l-.23 1.154h2.09a.41.41 0 0 0 .413-.412c0-1.524-1.073-2.606-2.983-3.355-1.885-.74-4.23-.988-5.891-.988-1.662 0-4.008.247-5.894.988-1.91.75-2.982 1.831-2.982 3.356 0 .227.184.411.412.411h2.091l-.231-1.154a1.126 1.126 0 0 1 .807-1.307l1.29-.351zM15.125 17a3.126 3.126 0 1 1-6.252 0 3.126 3.126 0 0 1 6.252 0m8-9.537a2.66 2.66 0 0 1-2.662 2.662H18.22a2.126 2.126 0 0 1-2.084-2.541l.054-.276-.275-.074a14.9 14.9 0 0 0-7.347-.124l-.482.124-.278.074.056.276a2.125 2.125 0 0 1-2.083 2.541H3.537A2.66 2.66 0 0 1 .875 7.463c0-2.924 2.19-4.578 4.41-5.45C7.532 1.132 10.187.87 12.002.87s4.468.262 6.713 1.143c2.221.872 4.41 2.526 4.41 5.45"
      />
    </svg>
  );
}
